module.exports = __webpack_public_path__ + "static/media/info_04.4492e610.jpg";